import React from 'react';
import B2BPanelCards from '../components/B2BPanelCards';
import FAQ from '../components/FAQ';
import ContactSection from '../components/ContactSection';

const B2BPage = () => {
  return (
    <>
      <B2BPanelCards />
      <FAQ />
      <ContactSection />
    </>
  );
};

export default B2BPage;
